import { AltOption } from "../../assets/svg/AltOption";
import { ButtonPressH } from "../../assets/svg/ButtonPressH";
import { ButtonPressR } from "../../assets/svg/ButtonPressR";
import { ClickAndMousewheel } from "../../assets/svg/ClickAndMousewheel";
import { HotkeyCtrl } from "../../assets/svg/HotkeyCtrl";
import { HotkeyOne } from "../../assets/svg/HotkeyOne";
import { HotkeyThree } from "../../assets/svg/HotkeyThree";
import { HotkeyTwo } from "../../assets/svg/HotkeyTwo";
import { LeftClick } from "../../assets/svg/LeftClick";
import { MouseWheelClick } from "../../assets/svg/MouseWheelClick";
import { RightClick } from "../../assets/svg/RightClick";
import { WASD } from "../../assets/svg/WASD";
import s from "./SceneHint.module.scss";

const hintBlocks = [
  {
    icon: <LeftClick />,
    text: "Hold LMB to rotate the camera position",
  },
  {
    icon: <LeftClick />,
    text: "Use LMB to select and  move objects",
  },
  {
    icon: <RightClick />,
    text: "Hold RMB to raise / lower the camera & move position",
  },
  {
    icon: <MouseWheelClick />,
    text: "Use Mouse Wheel to zoom in / out",
  },
  {
    icon: <ClickAndMousewheel />,
    text: "Use RMB + Mouse Wheel to change camera velocity",
  },
  {
    icon: <HotkeyOne />,
    text: "Press 1 to Select Move Tool",
  },
  {
    icon: <AltOption />,
    text: "Hold Alt/Option while using the Move Tool to Move Gizmo",
  },
  {
    icon: <HotkeyTwo />,
    text: "Press 2 to Select Rotate Tool",
  },
  {
    icon: <HotkeyCtrl />,
    text: "Hold Ctrl/Control while using the Rotate Tool to Rotate Gizmo",
  },
  {
    icon: <HotkeyThree />,
    text: "Press 3 to Select Scale Tool",
  },
  {
    icon: <ButtonPressR />,
    text: "Press R to reset the model to its initial position",
  },
  {
    icon: <ButtonPressH />,
    text: "Press H to show hints",
  },
  {
    icon: <WASD />,
    text: "Use WASD and QE to move  the camera",
  },
];

export const SceneHint = () => {
  return (
    <div className={s.wrapper}>
      {hintBlocks.map((block, index) => (
        <div key={index} className={s.item}>
          <div className={s.image}>{block.icon}</div>
          <div className={s.text}>
            <b>{block.text}</b>
          </div>
        </div>
      ))}
    </div>
  );
};
